// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2251q","noInteraction":"EventWrapper_noInteraction__3cV5R","pointerPassthrough":"EventWrapper_pointerPassthrough__2juMH"};